import { posNegGradientLine } from 'utils/components/TimeSeriesChart/posNegGradientLine';
import { curveStepAfter } from 'd3-shape';
import { AnySeries, seriesSvgMulti } from '@d3fc/d3fc-series';
import gridlines from 'utils/components/TimeSeriesChart/gridlines';
import { extentLinear } from '@d3fc/d3fc-extent';
import { withOppositeAccessor } from 'utils/d3fc/accessors';
import { line } from 'utils/components/TimeSeriesChart/line';
import classnames from 'classnames';
import { OrderFill } from 'widgets/fillsGraph/fillsGraphData';
import { PnLConfig } from 'widgets/fillsGraph/store/configuration/FillsGraphConfiguration';
import { FillsGraphPlChartItem } from 'widgets/fillsGraph/pl/fillsGraphPlData';

const yTicks = 6;

const realizedSeries = posNegGradientLine<OrderFill>('realizedPnl').map(
    (lineSeries) => lineSeries.curve(curveStepAfter)
);

const totalSeries = line((d: FillsGraphPlChartItem) => d.totalPnl, 'total');
const unrealizedSeries = line(
    (d: FillsGraphPlChartItem) => d.unrealizedPnl,
    'unrealized'
);
export const getChartSeries: (
    timeSeries: FillsGraphPlChartItem[],
    impactCost: number | undefined
) => AnySeries = (timeSeries, impactCost) => {
    return seriesSvgMulti().series([
        gridlines(yTicks, true),
        line(() => (impactCost ?? 0) * -1, 'est-impact-cost'),
        ...realizedSeries,
        unrealizedSeries,
        totalSeries,
    ]);
};

export function computeYDomain(
    config: PnLConfig,
    data: FillsGraphPlChartItem[]
): [number, number] {
    const { displayRealizedPnL, displayUnrealizedPnL, displayTotalPnL } =
        config;

    const accessors = [];

    displayRealizedPnL &&
        accessors.push(
            ...withOppositeAccessor((d: FillsGraphPlChartItem) => d.realizedPnl)
        );

    displayUnrealizedPnL &&
        accessors.push(
            ...withOppositeAccessor(
                (d: FillsGraphPlChartItem) => d.unrealizedPnl
            )
        );

    displayTotalPnL &&
        accessors.push(
            ...withOppositeAccessor((d: FillsGraphPlChartItem) => d.totalPnl)
        );

    return data.length > 0
        ? extentLinear().accessors(accessors).pad([0.1, 0.1])(data)
        : [0, 1];
}

export function getHideSeriesClasses(config: PnLConfig) {
    const { displayRealizedPnL, displayUnrealizedPnL, displayTotalPnL } =
        config;

    return classnames(
        !displayRealizedPnL && 'hide-realized-line',
        !displayUnrealizedPnL && 'hide-unrealized-line',
        !displayTotalPnL && 'hide-total-line'
    );
}
